<template lang="html">
  <v-textarea
    ref="input"
    v-model="internalValue"
    v-bind="$attrs"
    :label="internalLabel"
    :rules="internalRules"
    data-lpignore="true"
    auto-grow
    autocomplete="off"
    v-on="$listeners"
    @focus="handleFocus"
    @change="handleChange"
  />
</template>

<script>
import helpers from '@/mixins/helpers'
import element from '@/mixins/element'

export default {
  mixins: [ helpers, element ],
  props: {
    value: String
  },
  data () {
    return {
      lazyValue: this.value,
      requiredRule: v => this.valueValid(v) || `${this.$attrs.label || 'This field'} is required`
    }
  },
  computed: {
    internalValue: {
      get () {
        return this.lazyValue
      },
      set (val) {
        this.lazyValue = val
        this.$emit('input', val)
      }
    }
  },
  watch: {
    value (val) {
      this.lazyValue = val
      this.resetInputStyle()
    }
  },
  methods: {
    handleFocus () {
      this.$emit('focus')
      this.resize()
    },
    handleChange (e) {
      this.$emit('change', e)
      this.resize()
    },
    resize () {
      this.$refs.input.calculateInputHeight()
    },
    resetInputStyle () {
      this.$refs.input.$el.getElementsByTagName('textarea')[0].style = ''
    }
  }
}
</script>

<style lang="css" scoped>

</style>
